import { resolveComponent as d, openBlock as t, createElementBlock as a, Fragment as l, renderList as n, createBlock as c, normalizeStyle as f, createCommentVNode as o } from "vue";
import { _ as S } from "./_plugin-vue_export-helper-dad06003.js";
import { S as y } from "./StarIcon-94ec56f8.js";
const k = {
  name: "TestimonialRating",
  components: {
    StarIcon: y
  },
  props: {
    rate: {
      type: Number,
      default: 0
    },
    color: {
      type: String,
      default: "#eaaa08"
    }
  },
  computed: {
    fullStars() {
      return Math.round(this.rate);
    },
    emptyStars() {
      return 5 - this.fullStars;
    }
  }
}, g = { class: "flex space-x-1" };
function x(m, p, u, _, i, e) {
  const s = d("StarIcon");
  return t(), a("div", g, [
    e.fullStars > 0 ? (t(!0), a(l, { key: 0 }, n(e.fullStars, (r) => (t(), c(s, {
      key: r,
      class: "h-4 sm:h-5 w-4 sm:w-5",
      style: f({ color: u.color })
    }, null, 8, ["style"]))), 128)) : o("", !0),
    e.emptyStars > 0 ? (t(!0), a(l, { key: 1 }, n(e.emptyStars, (r) => (t(), c(s, {
      key: r,
      class: "h-4 sm:h-5 h-4 sm:w-5 ct-fg-senary"
    }))), 128)) : o("", !0)
  ]);
}
const R = /* @__PURE__ */ S(k, [["render", x]]), v = {
  name: "TestimonialRating",
  components: {
    StarIcon: y
  },
  props: {
    rate: {
      type: Number,
      default: 0
    },
    color: {
      type: String,
      default: "#eaaa08"
    }
  },
  computed: {
    fullStars() {
      return Math.round(this.rate);
    },
    emptyStars() {
      return 5 - this.fullStars;
    }
  }
}, w = { class: "flex space-x-1" };
function I(m, p, u, _, i, e) {
  const s = d("StarIcon");
  return t(), a("div", w, [
    e.fullStars > 0 ? (t(!0), a(l, { key: 0 }, n(e.fullStars, (r) => (t(), c(s, {
      key: r,
      class: "h-4 w-4",
      style: f({ color: u.color })
    }, null, 8, ["style"]))), 128)) : o("", !0),
    e.emptyStars > 0 ? (t(!0), a(l, { key: 1 }, n(e.emptyStars, (r) => (t(), c(s, {
      key: r,
      class: "h-4 w-4 ct-fg-senary"
    }))), 128)) : o("", !0)
  ]);
}
const T = /* @__PURE__ */ S(v, [["render", I]]), C = {
  name: "TestimonialRating",
  components: {
    StarIcon: y
  },
  props: {
    modelValue: {
      type: Number,
      default: 0
    },
    color: {
      type: String,
      default: "#eaaa08"
    }
  },
  emits: ["update:modelValue"],
  computed: {
    model: {
      get() {
        return this.modelValue;
      },
      set(m) {
        this.$emit("update:modelValue", m);
      }
    },
    fullStars() {
      return Math.round(this.model);
    },
    emptyStars() {
      return 5 - this.fullStars;
    }
  }
}, V = { class: "flex space-x-1" };
function M(m, p, u, _, i, e) {
  const s = d("StarIcon");
  return t(), a("div", V, [
    e.fullStars > 0 ? (t(!0), a(l, { key: 0 }, n(e.fullStars, (r) => (t(), c(s, {
      key: r,
      class: "cursor-pointer h-6 w-6 hover:scale-110",
      style: f({ color: u.color }),
      onClick: (h) => e.model = r
    }, null, 8, ["style", "onClick"]))), 128)) : o("", !0),
    e.emptyStars > 0 ? (t(!0), a(l, { key: 1 }, n(e.emptyStars, (r) => (t(), c(s, {
      key: r,
      class: "cursor-pointer h-6 w-6 ct-fg-senary hover:scale-110",
      onClick: (h) => e.model = r + e.fullStars
    }, null, 8, ["onClick"]))), 128)) : o("", !0)
  ]);
}
const $ = /* @__PURE__ */ S(C, [["render", M]]);
export {
  R as StarsMd,
  $ as StarsPicker,
  T as StarsSm
};
